import React, { useState } from 'react';

type CabDurationProps = {
  handleDuration: (hour: string, kms: string, evt?: any) => void;
  closeTravelForPopup: () => void;
  labelText?: string;
  activeHrPackages?: string[];
  selectedPackage: string;
};
const CabDuration = React.memo(
  ({
    handleDuration,
    closeTravelForPopup,
    labelText,
    activeHrPackages = [],
    selectedPackage
  }: CabDurationProps) => {
    const [hrPackages, setHRPackages] = useState(
      activeHrPackages.length > 0
        ? activeHrPackages
        : [
            '1 hr, 10 kms',
            '2 hrs, 20 kms',
            '3 hrs, 30 kms',
            '4 hrs, 40 kms',
            '5 hrs, 50 kms',
            '6 hrs, 60 kms',
            '6 hrs, 70 kms',
            '8 hrs, 80 kms',
            '9 hrs, 90 kms',
            '10 hrs, 100 kms'
          ]
    );

    const renderSlots = () => {
      return hrPackages.map((timeDistanceString, index) => {
        const [hour, kms] = timeDistanceString.split(', ');
        return (
          <li
            className={`truncate ${
              selectedPackage === timeDistanceString ? 'selected' : ''
            }`}
            key={timeDistanceString}
            onClick={() => {
              handleDuration(hour, kms);
            }}
          >
            <p className="font14 latoBold appendBottom2">
              <b>{hour}</b> {kms}
            </p>
          </li>
        );
      });
    };

    return (
      <div className={`travelForPopup`}>
        <p className="travelForPopup--header">
          <span className="font18 latoBold blackText">
            {labelText ? labelText : 'Select Duration'}
          </span>
          <span className="close" onClick={() => closeTravelForPopup()}></span>
        </p>
        <ul>{renderSlots()}</ul>
      </div>
    );
  }
);

export default CabDuration;
